<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    :width="width"
    :height="height"
    viewBox="0 0 48 48"
  >
    <g fill="none" fill-rule="evenodd">
      <g>
        <g>
          <g>
            <g>
              <g fill="#2C4A7D">
                <path
                  d="M42.463 0c.084-.006.165.01.238.042l.02.01c.018.008.035.018.052.029l.017.012c.015.01.03.022.044.035l.029.028.03.034.013.018c.018.025.029.043.039.062l-.039-.062c.019.026.035.054.048.082.043.09.059.197.036.308L43 .533l-.002.023-.007.042-8 40c-.07.355-.483.519-.778.31L11 24.524v14.004l6.21-4.435c.2-.143.468-.117.638.048l.059.068c.143.2.117.469-.048.64l-.068.058-7 5c-.308.22-.726.031-.784-.323L10 39.5V23.818l-9.788-6.91c-.302-.213-.271-.657.03-.836l.08-.04 42-16 .024-.008.035-.01c.018-.004.036-.008.053-.01l.019-.002zm-.704 1.647L11.32 23.524 34.16 39.647l7.599-38zm-2.663.683L1.555 16.632l8.902 6.282L39.096 2.33z"
                  transform="translate(-696 -184) translate(492 136) translate(204 48) translate(0 4)"
                />
              </g>
              <g>
                <path
                  fill="#1FD876"
                  d="M8 0C3.6 0 0 3.6 0 8s3.6 8 8 8 8-3.6 8-8-3.6-8-8-8z"
                  transform="translate(-696 -184) translate(492 136) translate(204 48) translate(0 4) translate(32 11)"
                />
                <path
                  fill="#FFF"
                  d="M7 11.4L3.6 8 5 6.6 7 8.6 11 4.6 12.4 6z"
                  transform="translate(-696 -184) translate(492 136) translate(204 48) translate(0 4) translate(32 11)"
                />
              </g>
            </g>
          </g>
        </g>
      </g>
    </g>
  </svg>
</template>

<script>
import VueTypes from 'vue-types';
export default {
  name: 'PlaneWithTickIcon',
  props: {
    height: VueTypes.string.def('48'),
    width: VueTypes.string.def('48'),
  },
};
</script>

<style lang="scss"></style>
